import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './OperatorUploadFolder.css';

const OPERATOR_ROOT = process.env.REACT_APP_OPERATOR_START_PATH || '/operator';

function OperatorUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={OPERATOR_ROOT}
      sessionPrefix="operator_folder"
    />
  );
}

OperatorUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default OperatorUploadFolder;
